import {React,useState,useEffect} from "react";
import {toast} from 'react-toastify'
import { useSelector } from "react-redux";
import {useHistory} from 'react-router-dom'
import ReactLoading from 'react-loading';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';

import './ServiceShow.scss'
import Product from '../Product/Product';
import ProductMobile from '../Product/ProductMobile';
import { getData } from "../Services/APIService";
import config from "../Services/config.json";
import JButton from '../../components/Button/JButton';

const ServiceShow= ({serviceType,modem,tag}) => {

    const history = useHistory();
    const customer = useSelector(state => state.customer);

    const [getItems,setItems] = useState([]);
    const [getIndex,setIndex] = useState(0);
    const [getAll,setAll] = useState(0);
    const [getLoading,setLoading] = useState(true);
    const [getLoadingMore,setLoadingMore] = useState(false);

    const [getCat,setCat] = useState(0);
    const [getDuration,setDuration] = useState(0);
    const [getTraffic,setTraffic] = useState(0);
    const [getSpeed,setSpeed] = useState(0);
    const [getFilterChanged,setFilterChanged] = useState(0);

    const ItemsDuration = [
        {value:'0',label:'همه',className:'drpDownItems'},
        { value: '1', label: 'یک ماهه', className: 'drpDownItems' },
        { value: '2', label: '45 روزه', className: 'drpDownItems' },
        { value: '3', label: 'سه ماهه', className: 'drpDownItems' },
        { value: '4', label: 'شش ماهه', className: 'drpDownItems' },
        { value: '5', label: 'یک ساله', className: 'drpDownItems' },
        { value: '6', label: 'دو ساله', className: 'drpDownItems' },
    ];

    const ItemsTraffic = [
        {value:'0',label:'همه',className:'drpDownItems'},
        {value:'-1',label:'نامحدود',className:'drpDownItems'},
        {value:'1',label:'5 گیگ',className:'drpDownItems'},
        {value:'2',label:'10 گیگ',className:'drpDownItems'},
        {value:'3',label:'20 گیگ',className:'drpDownItems'},
        //{value:'XXXXXXXX',label:'XXXXXXXX',className:'drpDownItems'},
    ];

    const ItemsSpeed = [
        {value:'0',label:'همه',className:'drpDownItems'},
        {value:'128',label:'128 کیلو بیت',className:'drpDownItems'},
        {value:'256',label:'256 کیلو بیت',className:'drpDownItems'},
        {value:'512',label:'512 کیلو بیت',className:'drpDownItems'},
        {value:'1024',label:'یک مگ',className:'drpDownItems'},
        {value:'2048',label:'2 مگ',className:'drpDownItems'},
        {value:'3072',label:'3 مگ',className:'drpDownItems'},
        {value:'4096',label:'4 مگ',className:'drpDownItems'},
        {value:'8192',label:'8 مگ',className:'drpDownItems'},
        {value:'16384',label:'16 مگ',className:'drpDownItems'},
        {value:'20480',label:'20 مگ',className:'drpDownItems'},
        {value:'32768',label:'32 مگ',className:'drpDownItems'},
        {value:'40960',label:'40 مگ',className:'drpDownItems'},
        {value:'81920',label:'80 مگ',className:'drpDownItems'},
    ];

    const ItemsCat = [
        {value:'0',label:'همه',className:'drpDownItems'},
        {value:'1',label:'وِیژه',className:'drpDownItems'},
        {value:'3',label:'نقره ای',className:'drpDownItems'},
        {value:'2',label:'برنزی',className:'drpDownItems'},
    ];

    useEffect( () => {

        if(customer.serviceType==1 && customer.serviceCode==0){
            history.push("/");
            return;
       }
       
        window.scrollTo(0, 0)
        if(customer.serviceType === 0){
            history.push("/");
        }
        else
            handleLoadInfo();
   },[]);

   useEffect( () => {
       handleLoadInfo();
    },[getFilterChanged]);
   
    //####################################################################

    const handleFilters = (type,code) =>{
        
        // console.log("StoreLog: ",getItems.length);
        setItems([]);
        setIndex(0);

        if(type===1){
            setCat(code);
        }
        else if(type===2){
            setDuration(code);
        }
        else if(type===3){
            setTraffic(code);
        }
        else if(type===4){
            setSpeed(code);
        }

        setFilterChanged(getFilterChanged+1);
    }

    const handleLoadMore = async (e) =>{
        e.preventDefault();

        setLoadingMore(true);
        handleLoadInfo();
        setLoadingMore(false);
    }
    
    const handleLoadInfo = async () =>{
        setLoading(true);

        let index=getIndex+1;
        setIndex(index);

        const info={
            token: config.APIKey,
            tag: tag,
            type: serviceType,
            category:getCat,
            duration:getDuration,
            traffic:getTraffic,
            speed:getSpeed,
            modem: modem,
            index:index,
            size:10,
            // selectedService:(((serviceType === 2 || serviceType === 3) && ((customer.ServiceHasEquipment && modem === 1) || (!customer.ServiceHasEquipment  && modem === 0) ) ) || (serviceType === 1 && tag=== 4) ? customer.serviceCode : 0)
            selectedService:(((serviceType === 2 || serviceType === 3) && ((customer.ServiceHasEquipment && modem === 1) || (!customer.ServiceHasEquipment  && modem === 0) ) )  ? customer.serviceCode : 0)
         };

        try{
            const {data}=await getData('store/getPackages',info);
            
            if (data.Result !== 4 && data.Message!== null) {
                toast.error(data.Message,{position:'bottom-left',closeButton:true,closeOnClick:true});
            }
            else if (data.Result !== 4) {
                //toast.error("خطایی رخ داده است",{position:'bottom-left',closeButton:true,closeOnClick:true});
                console.log("StoreError: ","خطایی رخ داده است");
            }
            else{
                setItems(getItems.concat(data.packages));
                setAll(data.all);
            }
        }
        catch(ex){
            // toast.error("مشکلی پیش آمده.", {
            //     position: "bottom-left",
            //     closeOnClick: true
            // });
            console.log("StoreError: ",ex.Message);
        }

        setLoading(false);
    }
    
    return (
        <div>
                <div className={`selectServiceTitle${serviceType === 1 && tag === 0 ? " selectServiceTitleADSL" : (getItems.length===0 && serviceType!=1 ? " selectServiceTitleNone" : (serviceType===1 && tag === 4 ? " selectServiceTitleCenter" : ""))}`}>
                    
                    {serviceType === 1 && tag === -1 && getItems.length>0 ?
                    (
                        <>
                        <div className="filterADSL0">
                            <div className="filtersDurationTrafficSpeed">
                                {/* <div className="filtersSpeed">
                                    <Dropdown options={ItemsSpeed} placeholder="همه" onChange={selection => handleFilters(4,selection.value)} className="drpDown" arrowClassName="drpDownArrow" placeholderClassName="drpDownPlace" menuClassName="drpDownMenu" controlClassName="drpDownItems"/>
                                    <span>سرعت</span>
                                </div> */}
                                {/* <div className="filtersTraffic">
                                    <Dropdown options={ItemsTraffic} placeholder="همه" onChange={selection => handleFilters(3,selection.value)} className="drpDown" arrowClassName="drpDownArrow" placeholderClassName="drpDownPlace" menuClassName="drpDownMenu" controlClassName="drpDownItems"/>
                                    <span>حجم</span>
                                </div> */}
                                {/* <div className="filtersDuration">
                                    <Dropdown options={ItemsDuration} onChange={selection => handleFilters(2,selection.value)} placeholder="همه" className="drpDown" arrowClassName="drpDownArrow" placeholderClassName="drpDownPlace" menuClassName="drpDownMenu" controlClassName="drpDownItems"/>
                                    <span>مدت دوره</span>
                                </div> */}
                            </div>
                            <div className="filtersCat">
                                {/* <div className="filtersCat1">
                                    <div className={`filterCat${getCat === 1 ? " filterCatSelected" : ""}`} onClick={() => handleFilters(1,1)}>ویژه</div>
                                    <div className={`filterCat${getCat === 3 ? " filterCatSelected" : ""}`} onClick={() => handleFilters(1,3)}>نقره ای</div>
                                    <div className={`filterCat${getCat === 2 ? " filterCatSelected" : ""}`} onClick={() => handleFilters(1,2)}>برنزی</div>
                                    <div className={`filterCat${getCat === 0 ? " filterCatSelected" : ""}`} onClick={() => handleFilters(1,0)}>همه</div>
                                </div>
                                <div className="filtersCat2">
                                    <Dropdown options={ItemsCat} onChange={selection => handleFilters(1,selection.value)} placeholder="همه" placeholderClassName="drpDownPlace" menuClassName="drpDownMenu" controlClassName="drpDownBlack"/>
                                </div> */}
                            </div>
                            {/* <label>: انتخاب سرویس</label>
                            <label className="fa fa-wifi"></label> */}
                            {modem === 1 ?
                                <>
                                <label>سرویس های با مودم</label>
                                <span className="fa fa-wifi"></span>
                                </> 
                            :
                                <>
                                <label>سرویس های بدون مودم</label>
                                <span className="fa fa-wpforms"></span>
                                </> 
                            }
                        </div> 
                        <div  className="filterADSLMobile">
                            {/* <label>: انتخاب سرویس</label>
                            <label className="fa fa-wifi"></label> */}
                             {modem === 1 ?
                                <>
                                <label>سرویس های با مودم</label>
                                <span className="fa fa-wifi"></span>
                                </> 
                            :
                                <>
                                <label>سرویس های بدون مودم</label>
                                <span className="fa fa-wpforms"></span>
                                </> 
                            }
                        </div>
                        </>
                    )
                    :
                    (
                        getItems.length>0 ?
                            serviceType === 2 ?
                            (
                                modem === 1 ?
                                    <>
                                    <label>سرویس های با مودم</label>
                                    <span className="fa fa-wifi"></span>
                                    </> 
                                :
                                    <>
                                    <label>سرویس های بدون مودم</label>
                                    <span className="fa fa-wpforms"></span>
                                    </> 
                            )
                            :
                            (
                                serviceType === 3 ?
                                <>
                                <label>سرویس های ویژه</label>
                                <span className="fa fa-wifi"></span>
                                </>
                                :
                                <>
                                <label>سرویس های پیشنهادی</label>
                                </>
                            )
                        :
                            null
                    )
                    }
                </div>
                {getItems.length>0 ? 
                <>
                    <div className="items">
                        {getLoading ? <ReactLoading type="bubbles" color={"#ff8035"} height={150} width={120} className="reactLoading" /> : null}
                        {getItems.map(item => (
                        <div className="oneProduct">
                            {
                                customer.isMobile || customer.isTablet ?
                                    <ProductMobile
                                        code={item.code}
                                        productImage={item.tag != 3 ? (!item.images[1] || item.images[1]==='' ? item.images[0] : item.images[1]) : (!item.images[3] || item.images[3]==='' ? item.images[2] : item.images[3])}
                                        serviceType={item.serviceType}
                                        title1=''//{item.description[0]}
                                        title2={item.description[1]}
                                        title3={item.description[2]}
                                        title4={item.description[3]}
                                        title5={item.description[4]}
                                        title6={item.description[5]}
                                        mainPrice={item.mainPrice}
                                        discountPrice={item.discountPrice}
                                        canSelect={true}
                                        selected={item.code=== customer.serviceCode ? true : false}
                                        hasEquipment={item.equipmentCount>0 ? true : false}
                                        productDes={item.productDes}
                                    />
                                    :
                                    <Product
                                        code={item.code}
                                        productImage={item.tag != 3 ? item.images[0] : item.images[2]}
                                        serviceType={item.serviceType}
                                        title1=''//{item.description[0]}
                                        title2={item.description[1]}
                                        title3={item.description[2]}
                                        title4={item.description[3]}
                                        title5={item.description[4]}
                                        title6={item.description[5]}
                                        mainPrice={item.mainPrice}
                                        discountPrice={item.discountPrice}
                                        canSelect={true}
                                        selected={item.code === customer.serviceCode && customer.serviceCode>0 ? true : false}
                                        hasEquipment={item.equipmentCount>0 ? true : false}
                                        productDes={item.productDes}
                                    />
                            }
                        </div>))}
                    </div>
                    {getAll > (getIndex*10) ?
                    <div className="loadMore">
                        {/* <div className="btnLoadMore" onClick={() => handleLoadMore()}>
                            {
                                !getLoadingMore ?
                                <>
                                <span className="fa fa-download"></span>
                                <label>مشاهده بیشتر</label>
                                </>
                                :
                                <ReactLoading type="bubbles" color={"#ff8035"} className="reactLoadingMore" />
                            }
                        </div> */}
                        <div className="btnLoadMore">
                            <JButton handleClick={handleLoadMore} title={!getLoadingMore ? "مشاهده بیشتر" : <ReactLoading type="bubbles" color={"#ff8035"} className="reactLoadingMore" />} rightIcon={"fa fa-download"} type={""} noSize={true}/>
                        </div>
                    </div>
                    :null}
                </> :
                // serviceType === 1 ? <div className="notFoundItems">موردی یافت نشد</div> : null
                null
            }
        </div>
     );
}

export default ServiceShow;